module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Schleitheim-54f30bb0d6b40c9ba76941a5c661f02a.png";